import { default as axios } from "axios";
import { Any, Obj, Str } from "@kizmann/pico-js";

export default class AppService
{
    static paramUrl(url, params = {})
    {
        Obj.each(params, (val, key) => {
            url = url.replaceAll(`:${key}`, val);
        });

        return url;
    }

    static queryUrl(url, query = {})
    {
        if ( Any.isEmpty(query) ) {
            return url;
        }

        return url + '?' + Str.params(query);
    }

    static fetchData(url, config = {})
    {
        return axios.get(url, config);
    }

    static postData(url, body, config = {})
    {
        return axios.post(url, body, config);
    }

    static fetchStatus(config = {}, query = {})
    {
        return axios.get(this.queryUrl('/api/status', query), config);
    }

    static fetchTokens(config = {}, query = {})
    {
        return axios.get(this.queryUrl('/api/token', query), config);
    }
}